import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  MenuItem,
} from '@mui/material'
import { CustomInput } from '../../../components/custom-input/CustomInput'
import L from 'leaflet'
import { ILocation } from '../../../types/locations'

interface LocationSelectorProps {
  location: ILocation | null
  setLocation: (value: ILocation | null) => void
  takeaway: boolean
  setTakeaway: (value: boolean) => void
  locations: ILocation[]
  errorState: { location: boolean }
  t: (key: string) => string
  setPosition: (pos: L.LatLng | null) => void
  setCoordinates: (coords: L.LatLngExpression) => void
  getTranslatedName: (item: ILocation) => string
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  location,
  setLocation,
  takeaway,
  setTakeaway,
  locations,
  errorState,
  t,
  setPosition,
  setCoordinates,
  getTranslatedName,
}) => (
  <div className='checkout-page__container-location'>
    <div className='checkout-page__container-location-input'>
      <CustomInput
        select
        fullWidth
        error={!takeaway && !errorState.location}
        value={(location || '') as unknown as string}
        label={t('LOCATION')}
        placeholder='location'
        backgroundColor='#F0F0F0'
        variant='filled'
        onChange={(e) => {
          setLocation(e.target.value as unknown as ILocation)
          setTakeaway(false)
        }}
      >
        {locations.map((loc, index) => (
          <MenuItem key={index} value={loc as unknown as string}>
            {getTranslatedName(loc)}
          </MenuItem>
        ))}
      </CustomInput>
      {!takeaway && !errorState.location && (
        <FormHelperText error id='component-error-text'>
          {t('FIELD_REQUIRED')}
        </FormHelperText>
      )}
    </div>
    <div className='checkout-page__container-location-input'>
      <FormControlLabel
        label={t('PICKUP')}
        control={
          <Checkbox
            size='small'
            checked={takeaway}
            onChange={(e) => {
              setTakeaway(e.target.checked)

              if (e.target.checked) {
                setLocation(null)
                setPosition({ lat: 48.331216, lng: 26.87127 } as L.LatLng)
                setCoordinates({ lat: 48.331216, lng: 26.87127 })
              } else {
                setPosition(null)
              }
            }}
            style={{ color: 'var(--color-primary)' }}
          />
        }
      />
      <a
        className='checkout-page__container-location-input-map'
        onClick={(e) => {
          e.preventDefault()
          setPosition({ lat: 48.331216, lng: 26.87127 } as L.LatLng)
          setCoordinates({ lat: 48.331216, lng: 26.87127 })
        }}
      >
        {t('LOCATION_MAP')}
      </a>
    </div>
  </div>
)

export default LocationSelector
